import React, { useEffect, useState } from "react";
import api from '../axiosConfig';
import {
  formattedFutureMonthData,
  startOfFutureMonth,
  endOfFutureMonth,
  currentDate,
} from "../helpers";
import { useModalContext } from "../ModalContext";

const FutureMonthRowData = (type, user) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { currency } = useModalContext();

  useEffect(() => {
    const fetchData = () => {
      setLoading(true);
      api
        .post("/datawithccnohierrachy", {
          Filters: false,
          Startdayofmonth: startOfFutureMonth(),
          Enddateofmonth: endOfFutureMonth(),
          Currentdate: currentDate(),
          type: type,  
          user: user,
          currencyType: currency,
        })
        .then((response) => {
          const formattedData =
            response.data && formattedFutureMonthData(response.data);
          setData(formattedData || []); 
          setLoading(false);
        })
        .catch((error) => {
          console.error("There was an error fetching the data!", error);
          setError(error);
          setLoading(false);
        });
    };

    fetchData();
  }, [type]); 

  return { loading, data };
};

export default FutureMonthRowData;
